import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {POST_COORDINATOR_SELECT_CANDIDATE_URL} from '../../constants/apiUrls';
import {useCustomMutation} from '../utils/useCustomMutation';
import {ApiPathParam} from '../../models/SearchParamSchema';
import {PaginatedData} from '../../models/List';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface PostCoordinatorSelectCandidateRequestData {
  apiPathParam: ApiPathParam;
  q: string;
}

export interface PostCoordinatorSelectCandidateResponseData {
  uuid: string;
  examLevels: string[];
  nricFin: string;
  name: string;
  status: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PaginatedData<PostCoordinatorSelectCandidateResponseData>) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCoordinatorSelectCandidateListing = ({onSuccess, onError}: Input = {}) => {
  const postCoordinatorSelectCandidateListing = async (
      payload: PostCoordinatorSelectCandidateRequestData
  ) => {
    const res = await axiosClient.post<PaginatedData<PostCoordinatorSelectCandidateResponseData>>(
        POST_COORDINATOR_SELECT_CANDIDATE_URL(payload.apiPathParam),
        {
          q: payload.q,
        },
        {timeout: 7000}
    );
    return res.data;
  };

  return useCustomMutation(postCoordinatorSelectCandidateListing, {
    onSuccess,
    onError,
  });
};
